{
    "TelsysList_Column_TelSysID": "ID",
    "TelsysList_Column_Description": "Description",
    "TelsysList_Column_Trial": "Trial",
    "TelsysList_Trial_Yes": "Yes",
    "TelsysList_Trial_No": "No",
    "TelsysList_Column_PlatformType": "Platform type",
    "TelsysList_Column_Licence": "License",
    "TelsysList_Column_Partitions": "Partitions",
    "TelsysList_Column_Extensions": "Extensions",
    "TelsysList_Column_AcdAgents": "Agents",
    "TelsysList_Column_AppUsers": "Application users",
    "TelsysList_Column_Status": "Status",
    "TelsysList_Filter_PlatformType": "Platform type",
    "TelsysList_Filter_ReportLicence": "License",
    "TelsysList_Filter_ModuleStatus": "Status",
    "TelsysList_LicenceFilter_HistoricOnly": "Historic only",
    "TelsysList_LicenceFilter_Standard": "Standard / BLF",
    "TelsysList_LicenceFilter_Enterprise": "Enterprise",
    "TelsysList_LicenceFilter_Acd": "ACD",
    "TelsysList_LicenceFilter_None": "None",
    "TelsysList_LicenceFilter_Mixed": "Mixed",
    "TelsysList_LicenceFilter_Unknown": "Unknown",
    "TelsysList_ModuleStatus_mNeg1": "Unknown",
    "TelsysList_ModuleStatus_m0": "Just starting or closed down",
    "TelsysList_ModuleStatus_m1": "Stopped",
    "TelsysList_ModuleStatus_m2": "Starting",
    "TelsysList_ModuleStatus_m3": "Ending",
    "TelsysList_ModuleStatus_m4": "Disabled",
    "TelsysList_ModuleStatus_m5": "Running (inactive)",
    "TelsysList_ModuleStatus_m6": "Running (unlicensed)",
    "TelsysList_ModuleStatus_m7": "Starting core communications",
    "TelsysList_ModuleStatus_m8": "Starting device monitoring",
    "TelsysList_ModuleStatus_m9": "Stopping communications",
    "TelsysList_ModuleStatus_m10": "Running",
    "TelsysList_ModuleStatus_m11": "Running (warnings)",
    "TelsysList_ModuleStatus_m12": "Synchronising",
    "TelsysList_ModuleStatus_m13": "Synchronised",
    "TelsysList_ModuleStatus_m14": "Synchronised (warnings)",
    "TelsysList_ModuleStatus_m15": "Synchronise failed",
    "TelsysList_ModuleStatus_m16": "Not in service",
    "TelsysList_ModuleStatus_m17": "Communications ended ungracefully",
    "TelsysList_ModuleStatus_m18": "Synchronisation failed",
    "TelsysList_ModuleStatus_m19": "Bots disabled",
    "TelsysList_ModuleStatus_m20": "Bots disabled (warnings)",
    "TelsysList_ModuleStatus_m21": "Inactive (incorrect permission)",
    "TelsysList_CountLink_PartitionsAria": "Open partitions filtered to this telephony server",
    "TelsysList_CountLink_ExtensionsAria": "Open extensions (codes) filtered to this telephony server",
    "TelsysList_CountLink_AcdAgentsAria": "Open agents filtered to this telephony server",
    "TelsysList_CountLink_AppUsersAria": "Open application users filtered to this telephony server",
    "NAME": "TelsysListLanguage"
}
